import {$} from './env';

$.fn.rect = function () {
  if (!this.length) {
    return null; 
  }

  return this.get(0).getBoundingClientRect();
};
